import React from "react";

const NotFound = ({
    ImageUrl = "",
    title = "",
    isBtn = false,
    btnText = "",
    btnCallBack = () => {},
}) => {
    return (
        <>
            <div className="h-full max-w-full bg-white mt-[30px] mx-[30px] mb-10 pt-[100px] pb-[150px] text-center">
                <img
                    src={ImageUrl}
                    className="max-w-[260px] mx-auto mb-5 pointer-events-none"
                />
                <p className="text-ec-placeholder text-center font-inter font-semibold text-xl leading-8 mb-6">
                    {title}
                </p>
                {isBtn && (
                    <>
                        <button
                            className="font-inter py-[10px] px-4 border border-ec-primary rounded-lg 
                            font-medium text-ec-primary text-base capitalize hover:bg-ec-primary hover:text-white"
                            onClick={btnCallBack}
                        >
                            {btnText}
                        </button>
                    </>
                )}
            </div>
        </>
    );
};

export default NotFound;
